<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:hxSkuSalesChannel="{ row }">
        <el-tag
          v-if="row.v_hxSkuSalesChannel"
          size="mini"
          :type="
            row.hxSkuSalesChannel === 'H'
              ? 'success'
              : row.hxSkuSalesChannel === 'V'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_hxSkuSalesChannel }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="
              row.hxPreOrderStatus === 'D' || row.hxPreOrderStatus === 'R'
                ? 'danger'
                : row.hxPreOrderStatus === 'Y'
                ? 'success'
                : row.hxPreOrderStatus === 'S'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_hxPreOrderStatus }}
          </el-tag>
        </div>
        <el-link
          v-if="row.reviewComments"
          type="danger"
          :underline="false"
          style="font-size: 13px;"
          @click="showReviewComments(row)"
        >
          {{ $l('btn_showReviewComments') || '查看审核意见' }}
        </el-link>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:submitInfo="{ row }">
        <span>{{ row.submitByName }}</span>
        <br />
        <span>{{ row.submitTime }}</span>
      </template>
      <template v-slot:reviewInfo="{ row }">
        <span>{{ row.reviewByName }}</span>
        <br />
        <span>{{ row.reviewTime }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { hxPreOrderCode, hxPreOrderNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { hxPreOrderCode },
            query: { hxPreOrderNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'submit':
          this.submit(data)
          break
        case 'review':
          this.review(data)
          break
        case 'reject':
          this.$emit(menuType, data)
          break
      }
    },
    async del({ hxPreOrderCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxPreOrderDelApi({ hxPreOrderCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async submit({ hxPreOrderCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxPreOrderSubmitApi({ hxPreOrderCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('INDEX.tips_submission_failed') || '提交失败！'
        )
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async review({ hxPreOrderCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_question_review') || '是否审核通过？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxPreOrderReviewApi({ hxPreOrderCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_audit_failure') || '审核失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_audit_success') || '审核成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    showReviewComments({ reviewComments }) {
      this.$alert(
        reviewComments,
        this.$l('alert_title_reviewComments') || '审核意见',
        {
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: this.$l('INDEX.btn_cancel') || '关闭',
        }
      )
    },
  },
}
</script>
